// extracted by mini-css-extract-plugin
module.exports = {"Text":"List__Text_169mu","Link":"List__Link_CI8iU"};